// extracted by mini-css-extract-plugin
module.exports = {"aboutCont":"about_aboutCont__cK_S_","aboutBox":"about_aboutBox__86Mo9"};